export default "__VITE_PUBLIC_ASSET__0ee9759a__"